import React from "react";
import axios from "axios";

export default function BillingPortalLoader() {
        const res =         // Get Stripe publishable key
        axios.get("/stripe/config/",
        )
        .catch((error) => {
            console.log(error)
        })
        .then(response => {
            // console.log(response);
            // Create Checkout Session
            axios.get("/stripe/create-portal-session/",
            ).catch(error=>console.log(error))
            .then(res=> {return res})
        })
        return res;
}